<template>
  <RouterView/>
  <update-alert v-if="showUpdateAlert" @closeModal="showUpdateAlert = false"/>
  <notif-popup v-if="showNotifPopup" @closeModal="showNotifPopup = false"/>
  <AppConfirmDialog/>
  <Toast/>
</template>

<script setup>
import {RouterView} from 'vue-router'
import {computed, onMounted, onUnmounted, ref} from "vue";
import {useConfigStore} from "@/stores/config.js";
import {useUserStore} from "@/stores/user.js";
import router from "@/router/index.js";
import UpdateAlert from "@/views/updateAlert.vue";
import packageJson from "../package.json";
import {Toast} from "primevue";
import {useToast} from "primevue/usetoast";
import {getFCMToken, listenNotifications} from '@/services/notification'
import {showMessage} from "@/utils/showMessage.js";
import {useConfirm} from "primevue/useconfirm";
import NotifPopup from "@/views/notifPopup.vue";

const configStore = useConfigStore();
const userStore = useUserStore();
const showUpdateAlert = ref(false)
const toast = useToast();
const confirm = useConfirm();
const notificationSupported = typeof window !== 'undefined' && 'Notification' in window
const showNotifPopup = ref(notificationSupported && Notification.permission !== 'granted')
let stopListeningNotifications = null

async function getConfigs() {
  await configStore.getConfigs();
  if (configStore.latestVersion) {
    showUpdateAlert.value = true
  }
}

async function getBasicProfile() {
  if (userStore.getUserId !== 0) {
    await userStore.action_getBasicProfile();
  }/* else {
    await router.push({name: "Login"})
  }*/
}

onMounted(async () => {
  await getConfigs();
  await getBasicProfile();
  if (notificationSupported && Notification.permission === 'granted') {
    await getFCMToken(true)
  }
  stopListeningNotifications = await listenNotifications((payload) => {
    if (!payload.notification) {
      return
    }

    toast.add({
      severity: 'info',
      summary: payload.notification.title,
      detail: payload.notification.body,
      life: 5000
    })
  })
})

onUnmounted(() => {
  if (stopListeningNotifications) {
    stopListeningNotifications()
  }
})
</script>

<style scoped>
</style>
